import { EDataPacketDirection } from '@gaming1/g1-network';

// Friendlier names to describe the destination of the packet
export const packetDirectionNames: Record<EDataPacketDirection, string> = {
  [EDataPacketDirection.Request]: 'Client->Server',
  [EDataPacketDirection.Response]: 'Server->Client',
  [EDataPacketDirection.Push]: 'Push',
  [EDataPacketDirection.Broadcast]: 'Broadcast',
};
